import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./AboutUs.css";
import { useTranslation } from "react-i18next";

const EMAIL = "info@impcaterer.com";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <section id="about-us" className="about-hero d-flex align-items-center">
      <div className="about-overlay"></div>
      <Container className="position-relative">
        <Row className="align-items-stretch h-100">
          {/* Info Section */}
          <Col
            md={6}
            data-aos="fade-right"
            className="d-flex flex-column justify-content-center"
          >
            <h2 className="about-title mb-4">
              {t("about.sectionTitle")}
            </h2>
            <blockquote className="about-quote mb-4">
              <p
                dangerouslySetInnerHTML={{ __html: t("about.main") }}
              />
            </blockquote>
            <div className="d-flex flex-wrap gap-3">
              <a href={`mailto:${EMAIL}`} className="about-btn">
                {t("about.emailBtn", { email: EMAIL })}
              </a>
            </div>
          </Col>
          {/* Map Section */}
          <Col
            md={6}
            className="d-flex flex-column justify-content-center"
            data-aos="fade-left"
          >
            <div
                className="about-map rounded-4 shadow flex-grow-1 d-flex flex-column"
                style={{ height: "100%" }}
                >
                <iframe
                    title="Service Area Map"
                    src="https://www.google.com/maps/d/embed?mid=1lUiQx7K9ycye7rNAU49VpJx3Dc1CmAU&ehbc=2E312F&noprof=1"
                    width="100%"
                    height="400"
                    style={{
                  border: 0,
                  borderRadius: "1rem",
                  flex: 1,
                  minHeight: 500
                    }}
                    allowFullScreen
                    loading="lazy"
                />
                <div className="about-map-caption">
                    <i className="bi bi-geo-alt-fill me-1"></i>
                    {t("about.mapCaption")}
                </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;